import dayjs from "dayjs";
import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { Input } from "../../../../components/ui/Form/Input";
import { Select } from "../../../../components/ui/Form/Select";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { PERIOD_OPTIONS, RECOVERY_STATUS } from "../constants";
import { PeriodButton } from "../components/PeriodButton";

export function ResultsFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.results);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const isLoading =
    loading.resultsKpis || loading.resultsContactedKpis || loading.attempts;

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.results, event, history)
      }
    >
      <Filter.Container>
        <div className="flex w-full flex-wrap gap-2 pb-2">
          {PERIOD_OPTIONS.map((option) => (
            <PeriodButton
              key={option.value}
              option={option}
              active={filters.period === option.value}
              onSelect={(period) =>
                controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.results, period)
              }
              onApply={() =>
                controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.results, null, history)
              }
            />
          ))}
        </div>
        <div className="flex w-full flex-wrap gap-3">
          <Input.Root
            pickDate
            label="Início"
            value={dayjs(filters.from).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.results, "from", value)
            }
          />
          <Input.Root
            pickDate
            label="Fim"
            value={dayjs(filters.to).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.results, "to", value)
            }
          />
          <Select.Root
            label="Ausência mínima"
            value={filters.minDays}
            style={{ minWidth: 150, maxWidth: 210 }}
            onChange={(minDays) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { minDays })
            }
          >
            <Select.Option value="7">7 dias</Select.Option>
            <Select.Option value="15">15 dias</Select.Option>
            <Select.Option value="30">30 dias</Select.Option>
            <Select.Option value="45">45 dias</Select.Option>
            <Select.Option value="60">60 dias</Select.Option>
            <Select.Option value="90">90 dias</Select.Option>
          </Select.Root>
          <Select.Root
            label="Contato realizado"
            value={filters.contacted}
            style={{ minWidth: 170, maxWidth: 210 }}
            onChange={(contacted) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { contacted })
            }
          >
            <Select.Option value="all">Todos</Select.Option>
            <Select.Option value="true">Sim</Select.Option>
            <Select.Option value="false">Não</Select.Option>
          </Select.Root>
          <Select.Root
            label="Status"
            value={filters.status}
            style={{ minWidth: 240, maxWidth: 280 }}
            onChange={(status) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.results, { status })
            }
          >
            <Select.Option value="all">Todos</Select.Option>
            {Object.entries(RECOVERY_STATUS).map(([value, option]) => (
              <Select.Option key={value} value={value}>
                {option.label}
              </Select.Option>
            ))}
          </Select.Root>
        </div>
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={isLoading} />
          Atualizar resultados
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
